@for (block of spellContainingBlocks(); track block) {
  <div class="container" id="spells" cdkDropListGroup>
    <h2 class="section-subtitle">{{ block.class | titlecase }} Spells</h2>
    <mat-card appearance="outlined">
      <mat-card-content>
        <mat-icon color="primary" class="spell-info-icon"
          matTooltip="You may drag and drop spells from the spell book into your character's spell slots on the right. You may overcast spells, but you may not load spell into a slot of lower level">
          info
        </mat-icon>
        <h2>Available Spells</h2>
        <mat-tab-group>
          @for (_ of block.spellLevelsIter(); track _; let i = $index) {
            <mat-tab label="Level {{i+1}}">
              <mat-list cdkDropList (cdkDropListDropped)="drop($event)"
                [cdkDropListData]="block.spellbook.getSpells(i+1)">
                @for (spell of block.spellbook.getSpells(i+1); track spell) {
                  <mat-list-item cdkDrag
                    matTooltip="{{spell.description}}"
                    (click)="openSpellDialog(block.spellbook, spell, null, block.class)">
                    {{ spell.name }} (Level {{ spell.level }}) @if (spell.reversible) {
                    <em
                    matTooltip="This spell is reversible">*</em>
                  }
                  <div class="action-buttons">
                    <button mat-icon-button (click)="memorizeSpell(block, spell, $event)" aria-label="Memorize spell">
                      <mat-icon>save_alt</mat-icon>
                    </button>
                  </div>
                  <mat-divider></mat-divider>
                </mat-list-item>
              }
            </mat-list>
            <button color="primary" class="add-spell-button" mat-mini-fab
              (click)="openSpellDialog(block.spellbook, null, i+1, block.class)">
              <mat-icon>add</mat-icon>
            </button>
          </mat-tab>
        }
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-content>
      <character-spell-slots [block]="block"></character-spell-slots>
    </mat-card-content>
  </mat-card>
  @if (block.spellbook.spells.length) {
    <div class="print-only spells-known-head">
      <span>Spells Known</span>
      <span class="slot-capacity">Slots/day:@for (g of block.getMemorizedSpells(); track g.level) {&nbsp;L{{ g.level }}&nbsp;&times;{{ g.slots }}}</span>
    </div>
    <table class="print-only spells-known">
      <thead><tr><th>Spell</th><th class="lvl">Lvl</th><th class="prep">Prep</th></tr></thead>
      <tbody>
        @for (spell of knownSpells(block); track spell) {
          <tr>
            <td>{{ spell.name }}@if (spell.reversible) {&nbsp;*}</td>
            <td class="lvl">{{ spell.level }}</td>
            <td class="prep">@if (block.preparedCount(spell); as n) {&times;{{ n }}}</td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
}
